<template>
  <div class="about-page">
    <!-- Banner大图 -->
    <div class="banner">
      <img src="@/assets/mobileApp.jpg" alt="banner" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'HardwareDev'
}
</script>

<style scoped>
/* Banner */
.banner {
  position: relative;
}
.banner img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
